import { GlassCard } from "@/components/GlassCard";
import { SkeletonRows, ErrorNote } from "./helpers";

export const CrudCard = ({ icon: Icon, title, description, testId, id, loading, error, onRetry, isEmpty, emptyText, addLabel, onAdd, children }) => (
  <GlassCard className="p-6 md:p-8" hover={false} data-testid={testId}>
    <div id={id} className="scroll-mt-40">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03]">
            <Icon className="h-5 w-5 text-paper-100" aria-hidden="true" />
          </span>
          <div>
            <h3 className="font-display text-lg font-semibold text-paper-100">{title}</h3>
            {description && <p className="text-sm text-paper-500">{description}</p>}
          </div>
        </div>
        {onAdd && !loading && !error && (
          <button
            onClick={onAdd}
            data-testid={`${testId}-add`}
            className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-xs font-semibold text-black transition-transform duration-300 hover:scale-[1.03]"
          >
            {addLabel || "Add"}
          </button>
        )}
      </div>
      <div className="mt-6">
        {loading && <SkeletonRows testId={`${testId}-loading`} />}
        {!loading && error && <ErrorNote message={error.kind === "offline" || error.kind === "timeout" ? "Unable to connect to Xevon services." : error.message} onRetry={onRetry} testId={`${testId}-error`} />}
        {!loading && !error && isEmpty && (
          <p className="rounded-xl border border-white/5 bg-white/[0.02] px-4 py-6 text-center text-sm text-paper-500" data-testid={`${testId}-empty`}>
            {emptyText || "Nothing configured yet."}
          </p>
        )}
        {!loading && !error && !isEmpty && children}
      </div>
    </div>
  </GlassCard>
);

export const ListRow = ({ testId, children, actions }) => (
  <div
    className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-white/5 bg-white/[0.02] px-4 py-3"
    data-testid={testId}
  >
    <div className="min-w-0 flex-1">{children}</div>
    {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
  </div>
);

export const IconButton = ({ onClick, label, testId, danger, disabled, children }) => (
  <button
    onClick={onClick}
    aria-label={label}
    title={label}
    disabled={disabled}
    data-testid={testId}
    className={`rounded-full border p-2 transition-colors duration-300 disabled:opacity-40 ${
      danger
        ? "border-white/10 text-paper-500 hover:border-white/40 hover:text-paper-100"
        : "border-white/10 text-paper-400 hover:border-white/30 hover:text-paper-100"
    }`}
  >
    {children}
  </button>
);
